import { PropsWithChildren } from 'react';
import { attempt } from 'yoso';
import { useMemberSecurity } from '~/components/Member/MemberSecurity.hooks';
export const HomeSecurity = ({ children }: PropsWithChildren<any>) => (
  <>{attempt(children, useMemberSecurity())}</>
);
